export default "__VITE_PUBLIC_ASSET__77fd3de7__"